import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As an organization owner or team admin, you can add organization members to teams to give them access to a specific set of packages governed by the organization.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` An npm user must be a member of your organization before you can add them to a team. To add a member to your organization, see "`}<a parentName="p" {...{
          "href": "adding-members-to-your-organization"
        }}>{`Adding members to your organization`}</a>{`".`}</p>
    </Note>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-teams-tab'].text}</>
        <>{shared['organization-teams-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Beside the team you want to add members to, click `}<strong parentName="p">{`Members`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-teams/team-members.png" alt="Screenshot of the team members button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the "Username" field, type the npm username of the organization member you would like to add to your team.`}</p>
        <Screenshot src="/organizations/managing-teams/team-member-select.png" alt="Screenshot of the team member selection" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`+ Add User`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-teams/team-member-add-button.png" alt="Screenshot of the team member add button" mdxType="Screenshot" />
      </li>
    </ol>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` organization members are not notified when they are added to a team. We recommend telling the organization member you have added them to a team.`}</p>
    </Note>
    <h2>{`Managing teams from the CLI`}</h2>
    <p>{`If you would like to manage the membership of your team from
the command line interface (CLI), you can use:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm team
`}</code></pre>
    <p>{`For more information, see the `}<a parentName="p" {...{
        "href": "/cli/team"
      }}>{`CLI documentation on teams`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      